"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Chips/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _inbox = require('shared/hooks/inbox');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);












const ChipItem = ({ tab, label, count, isOn, onSelectTab }) => {
  const onClick = _react.useCallback.call(void 0, () => onSelectTab(tab), [onSelectTab, tab])
  const countText = count ? _inbox.formatPillCount.call(void 0, count) : null
  return (
    _react2.default.createElement('button', {
      type: "button",
      className: _classBuilder2.default.call(void 0, 'inbox-tabs--chip', isOn && 'is-on'),
      'aria-pressed': isOn,
      'aria-label': countText ? `${label}, ${countText}` : undefined,
      onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}

      ,  label 
      ,  countText && _react2.default.createElement('span', { className: "inbox-tabs--count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}},  countText ) 
    )
  )
}

const Chip = _react.memo.call(void 0, ChipItem) 







// Clear of the fade (the scroller's scroll-padding), which a browser's own
// scroll on focus ignores.
const scrollIntoView = (el) =>
  _optionalChain([el, 'optionalAccess', _ => _.scrollIntoView, 'optionalCall', _2 => _2({ block: 'nearest', inline: 'nearest' })])
// Only focus from the keyboard: a mouse press focuses the tab too, and moving
// the row under the pointer then reads as the row running away.
const onFocusChip = (e) => {
  if (_optionalChain([e, 'access', _3 => _3.target, 'access', _4 => _4.matches, 'optionalCall', _5 => _5(':focus-visible')])) scrollIntoView(e.target)
}

/* The inbox's tabs, one picked at a time, scrolling sideways when they
 * outgrow their row. The edge with more tabs past it fades, and the tab
 * you're on, or the one focused, scrolls into view. The Directory uses them
 * too. */
const Chips = ({ pills, activeTab, onSelectTab }) => {
  const ref = _react.useRef(null)
  const [cut, setCut] = _react.useState.call(void 0, { start: false, end: false })

  const measure = _react.useCallback.call(void 0, () => {
    const el = ref.current
    if (!el) return
    const start = el.scrollLeft > 1
    const end = el.scrollLeft + el.clientWidth < el.scrollWidth - 1
    setCut(c => (c.start === start && c.end === end ? c : { start, end }))
  }, [])

  // Counts arriving widen the tabs, and the list can resize.
  _react.useLayoutEffect.call(void 0, measure, [measure, pills])
  _react.useEffect.call(void 0, () => {
    const el = ref.current
    if (!el || typeof ResizeObserver === 'undefined') return
    const observer = new ResizeObserver(measure)
    observer.observe(el)
    return () => observer.disconnect()
  }, [measure])

  // Only when the tab changes: counts refresh all the time, and the row
  // mustn't jump back while you're looking along it.
  _react.useEffect.call(void 0, () => {
    scrollIntoView(_optionalChain([ref, 'access', _6 => _6.current, 'optionalAccess', _7 => _7.querySelector, 'call', _8 => _8('.is-on')]))
  }, [activeTab])

  // A mouse drag scrolls the row (a trackpad or wheel already does); the list's
  // drag guard keeps it from also picking a tab. The drag ends on release, and
  // also when the press is cancelled, the window loses focus, the button is no
  // longer down, or the tabs go away.
  const endDragRef = _react.useRef(null)
  const endDrag = _react.useCallback.call(void 0, () => {
    _optionalChain([endDragRef, 'access', _9 => _9.current, 'optionalCall', _10 => _10()])
    endDragRef.current = null
  }, [])
  _react.useEffect.call(void 0, () => endDrag, [endDrag])

  const onPointerDown = _react.useCallback.call(void 0, (e) => {
    const el = ref.current
    if (!el || e.pointerType !== 'mouse' || e.button !== 0) return
    endDrag()
    const startX = e.clientX
    const startScroll = el.scrollLeft
    const onMove = (m) => {
      if (!(m.buttons & 1)) return endDrag()
      el.scrollLeft = startScroll - (m.clientX - startX)
    }
    window.addEventListener('pointermove', onMove)
    window.addEventListener('pointerup', endDrag)
    window.addEventListener('pointercancel', endDrag)
    window.addEventListener('blur', endDrag)
    endDragRef.current = () => {
      window.removeEventListener('pointermove', onMove)
      window.removeEventListener('pointerup', endDrag)
      window.removeEventListener('pointercancel', endDrag)
      window.removeEventListener('blur', endDrag)
    }
  }, [endDrag])

  return (
    _react2.default.createElement('div', {
      ref: ref,
      className: _classBuilder2.default.call(void 0, 'inbox-tabs--chips', cut.start && 'is-cut-start', cut.end && 'is-cut-end'),
      onScroll: measure,
      onFocus: onFocusChip,
      onPointerDown: onPointerDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}}

      ,  pills.map(pill => (
        _react2.default.createElement(Chip, { key: String(pill.tab), ...pill, isOn: pill.tab === activeTab, onSelectTab: onSelectTab, __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}} )
      ))
    )
  )
}

exports. default = Chips
